module.exports = __webpack_public_path__ + "img/unchecked-box.ef501ca4.svg";